const UvjetiKoristenja = ({
    modalTitle,
    generateHeaderCloseIco
}) => {

    const uvjetiContent = () => {
        return (
            <div className="welcome-msg margin-top">
                <div className="row margin-bottom">
                    <div>
                        <div className="row middle margin-bottom">
                            <img src="./ivanko.jpg" className="avatar-img my-img" />
                            <h3><em>Dobrodošli na nethr.chat!<span className="block">Community chat, novosti/blog, play & date!</span></em></h3>
                        </div>
                        <p><em>Ja sam Ivanko Perišić. Radim web stranice i web/mobilne aplikacije koje se kreću od ekonomične prema premium razini. Nudim izradu, smještaj i održavanje u jednom. Cilj mi je dugoročna suradnja i preporuke. Radim za top digitalne agencije u RH i EU. Web stranice su besplatne za humanitarne udruge i neprofitne organizacije humanitarnog karaktera.

Ova aplikacija je reboot nekad popularnog chat portala koji je dobio nekoliko novih feature-a. To je svojevrsno ljubavno pismo pop-kulturi i pre-smartphone internetu. Svako dobro i guštajte.</em></p>
                        <p><a href="https://ivankoperisic.from.hr/" target="_blank" className="my-text">Ivanko Perišić</a> (<a target="_blank" className="my-text" href="https://wordpresshosting.hr">Hyperion WordPress Hosting</a>)</p>
                    </div>
                </div>
                <p></p>
                <div >
                    <p className="welcome-msg-title"><strong>Mogućnosti</strong></p>
                    <div className="app-cards">

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide4.webp" /></div>
                            <div className="app-card-content">
                                <span>Matchmaking</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Dating & friend finder. Pronađite osobu koja dijeli vaše interese – za prijateljstvo ili nešto više.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide1.webp" /></div>
                            <div className="app-card-content">
                                <span>Korisnici</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Korisnički profili. Surfajte kroz profile i pronađite nekoga zanimljivog.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide3.webp" /></div>
                            <div className="app-card-content">
                                <span>Multiplayer</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Pobjednik osvaja "winner" boju, 100% energije i ne može ga se ocrnit ili spasit. Pobjedama povećavate level.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide5.webp" /></div>
                            <div className="app-card-content">
                                <span>Shoutbox</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Kupujete, prodajete, iznajmljujete, poklanjate? Kreirajte svog shoutbota.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide6.webp" /></div>
                            <div className="app-card-content">
                                <span>Radio</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Playlista omiljenih YouTube video naših članova. Dodajte pjesmu ili vama zanimljivi YT video.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide7.webp" /></div>
                            <div className="app-card-content">
                                <span>nethr.chat wars sezone</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Korisnik se može "ocrnit" ili "obranit" i tako gubi ili dobiva energiju. Na kraju sezone se kreće ispočetka.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide9.webp" /></div>
                            <div className="app-card-content">
                                <span>News</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Uz nethr.chat robo vijesti i ti možeš biti urednik pa dodat vijesti/blog.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide10.webp" /></div>
                            <div className="app-card-content">
                                <span>Uskršnje jaje</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Ako pronađete i pritisnete točkicu negdje na ekranu osvajate "winner" boju.</div>


                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide11.webp" /></div>
                            <div className="app-card-content">
                                <span>nethr.chat eventi</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">nethr.chat organizira online i offline evente za svoje članove.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="app-card margin-bottom">
                            <div className="app-card-img-wrap"><img src="slides/slide12.webp" /></div>
                            <div className="app-card-content">
                                <span>Vježbaj tipkanje</span>
                                <div class="app-card-buttons">
                                    <div className="row app-card-border">
                                        <div class="app-card__subtext">Redovno vježbaj tipkanje da bi mogao pobjeđivati u multiplayeru.</div>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                        
                        <p className="welcome-msg-title"><strong>Pravila korištenja</strong></p>

<p>
  Ulaskom u chat prihvaćate da nećete objavljivati neistinite, uvredljive, prijeteće poruke ili one koje potiču mržnju prema pojedincima ili skupinama.
</p>

<ul>
  <li>Korištenje više korisničkih imena (nickova) nije dopušteno.</li>
  <li>Nije dozvoljeno korištenje nadimaka koji su nepristojni, uvredljivi ili sadrže vulgarne izraze.</li>
  <li>Zabranjeno je dijeljenje sadržaja pornografskog, uvredljivog ili neprimjerenog karaktera.</li>
  <li>Profilne slike (avatari) ne smiju sadržavati nepristojan, seksualno eksplicitan ili uvredljiv sadržaj.</li>
  <li>Provociranje, vrijeđanje i osobni napadi na druge korisnike strogo su zabranjeni.</li>
  <li>Nije dopušteno promoviranje drugih internetskih stranica, radio postaja ili chat servisa.</li>
  <li>Svako ponašanje koje uključuje prijetnje, uznemiravanje, klevetu, vrijeđanje ili izazivanje neugodnosti drugim korisnicima neće biti tolerirano.</li>
  <li>Dijeljenje bilo kakvog neprimjerenog, nezakonitog, rasističkog, diskriminirajućeg ili štetnog sadržaja također je strogo zabranjeno.</li>
  <li>Ako moderator nije u mogućnosti odmah reagirati, a osjećate se ugroženo, preporučujemo da kliknete na korisnički nadimak i odaberete opciju "Blokiraj korisnika".</li>
  <li>Svaki korisnik ima pravo na svoje mišljenje; ako se ne slažete s nekim stavovima, suzdržite se od vrijeđanja i neprimjerenog izražavanja kako biste izbjegli kazne poput utišavanja (mute) ili zabrane pristupa (ban).</li>
  <li>Javne rasprave i svađe nisu poželjne – nesuglasice pokušajte riješiti putem privatne poruke.</li>
  <li>Nemojte vršiti pritisak na moderatore da uklone pojedine korisnike osim ako oni ne krše pravila chata.</li>
  <li>Poštujte sve sudionike ovog chata.</li>
  <li>Chat koristite na vlastitu odgovornost; odgovorni ste za vlastite objave.</li>
  <li>Osobe mlađe od 18 godina ne smiju koristiti ovaj chat.</li>
</ul>
                        </div>


                        <div className="column left margin-top">
                        <p><strong>ODRICANJE ODGOVORNOSTI I KORIŠTENJE NA VLASTITU ODGOVORNOST:</strong></p>
                        <p>Ova platforma je napravljena u dobroj namjeri i pruža usluge kao što su zajednički chat, dijeljenje vijesti, upoznavanje korisnika (date finder), besplatan oglasnik isl. Sadržaj koji objavljuju korisnici nije pod direktnom kontrolom administratora, te ne preuzimamo odgovornost za točnost, zakonitost ili prikladnost korisnički generiranog sadržaja.
Korištenjem ove platforme, suglasni ste da je koristite na vlastitu odgovornost. Autor/izdavač ove platforme ne snosi odgovornost za bilo kakvu štetu, gubitak, emocionalnu nelagodu, tehničke probleme, prevare ili druge posljedice koje mogu nastati upotrebom servisa, uključujući ali ne ograničavajući se na:
neprikladne ili uvredljive poruke u chatu ili u komentarima, netočne ili obmanjujuće informacije u sekciji vijesti, neželjene, neiskrene ili štetne kontakte u date finderu, netočne, nelegalne ili prevarantske oglase u oglasniku.
Korištenjem platforme prihvaćate ove uvjete.</p>
                <p></p>
                <p>Sve upite slati na: <a href="mailto:info@nethr.chat">info@nethr.chat</a></p>
                <p></p>
                        </div>


                    </div>
                </div>

                <p className="welcome-msg-title"><strong>Korišteni resursi</strong></p>
                <ul>
                    <li>Dizajn: <a target="_blank" href="https://codepen.io/TurkAysenur">TurkAysenur</a></li>
                    <li>Ikone: <a target="_blank" href="https://icons8.com/">Icons8</a></li>
                    <li>Avatari: <a target="_blank" href="https://api.multiavatar.com/">Multiavatar API</a></li>
                    <li>Emoji: <a target="_blank" href="https://www.npmjs.com/package/emoji-picker-react">Emoji Picker React</a></li>
                    <li>Prijevod: <a target="_blank" href="https://www.bing.com/translator">Microsoft Bing Translation</a></li>
                    <li>Animirana pozadina: <a target="_blank" href="https://codepen.io/theprabir/pen/poGNBzO">Animated CSS Background</a></li>
                    <li>Font1: <a target="_blank" href="https://www.1001fonts.com/poppins-font.html">Poppins</a></li>
                    <li>Font2: <a target="_blank" href="https://www.dafont.com/sectar.font">Sectar</a></li>
                </ul>
                <p className="welcome-msg-title"><strong>Korištene tehnologije</strong></p>
                <div className="row multiline">
                    <a target="_blank" href="https://developer.mozilla.org/en-US/"><img className="tech-logo" src="./logotipi/fe.jpg" /></a>
                    <a target="_blank" href="https://nodejs.org/en"><img className="tech-logo" src="./logotipi/node.jpg" /></a>
                    <a target="_blank" href="https://expressjs.com/"><img className="tech-logo" src="./logotipi/express.jpg" /></a>
                    <a target="_blank" href="https://www.mysql.com/"><img className="tech-logo" src="./logotipi/mysql.jpg" /></a>
                    <a target="_blank" href="https://pptr.dev/"><img className="tech-logo" src="./logotipi/puppeteer.jpg" /></a>
                    <a target="_blank" href="https://socket.io/"><img className="tech-logo" src="./logotipi/socketio.jpg" /></a>
                    <a target="_blank" href="https://sequelize.org/"><img className="tech-logo" src="./logotipi/sequelize.jpg" /></a>
                    <a target="_blank" href="https://axios-http.com/"><img className="tech-logo" src="./logotipi/axios.jpg" /></a>
                    <a target="_blank" href="https://react.dev/"><img className="tech-logo" src="./logotipi/react.jpg" /></a>
                    <a target="_blank" href="https://sass-lang.com/"><img className="tech-logo" src="./logotipi/sass.jpg" /></a>
                    <a target="_blank" href="https://splidejs.com/"><img className="tech-logo" src="./logotipi/splide.jpg" /></a>
                </div>
                <p className="welcome-msg-title"><strong>Posebna pohvala:</strong> Damiru Sobolu i njegovom Iskon internetu</p>
            </div>
        )
    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    {uvjetiContent()}
                </div>

            </div>
        </div>
    )
}

export default UvjetiKoristenja